<template>
  <div :id="uuid" style="width: 100%;height: 400px">
  </div>
</template>

<script>
  // Import the echarts core module, which provides the necessary interfaces for using echarts.
  import * as echarts from 'echarts/core';
  // Import bar charts, all suffixed with Chart
  import {LineChart, BarChart} from 'echarts/charts';
  // Import the tooltip, title, rectangular coordinate system, dataset and transform components
  // all suffixed with Component
  import {
    TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, LegendComponent,
    LegendScrollComponent, LegendPlainComponent
  } from 'echarts/components';
  // Features like Universal Transition and Label Layout
  import {LabelLayout, UniversalTransition} from 'echarts/features';
  // Import the Canvas renderer
  // Note that including the CanvasRenderer or SVGRenderer is a required step
  import {CanvasRenderer} from 'echarts/renderers';

  // Register the required components
  echarts.use([
    TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, LineChart,
    LabelLayout, UniversalTransition, CanvasRenderer, LegendComponent, LegendScrollComponent,
    LegendPlainComponent, BarChart
  ]);

  import {uuid} from 'vue-uuid';

  export default {
    name: 'ELineChart',
    data() {
      return {
        uuid: uuid.v4(),
        currentChart: null
      }
    },
    props: {
      chartData: {
        type: Object,
        default: () => {
          return {
            labels: [],
            series: []
          }
        }
      }
    },
    watch: {
      chartData: {
        deep: true,
        handler() {
          this.updateData()
        }
      }
    },
    methods: {
      getOptions() {
        let series = this.chartData.series.map(s => {
          s.type = 'line'
          return s
        })

        return {
          legend: {
            orient: 'horizontal',
            top: 'top'
          },
          xAxis: {type: 'category',data: this.chartData.labels},
          yAxis: {},
          series: series
        };
      },
      updateData() {
        if (!this.currentChart) {
          let chartDom = document.getElementById(this.uuid);
          this.currentChart = echarts.init(chartDom);
        }
        let options = this.getOptions()
        this.currentChart.setOption(options, true)
      },
      onResize() {
        if (this.currentChart !== null && this.currentChart !== undefined) {
          this.currentChart.resize();
        }
      }
    },
    mounted() {
      this.updateData();
      addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
      removeEventListener("resize", this.onResize)
    }
  }
</script>
